import { render, staticRenderFns } from "./ProvinceList.vue?vue&type=template&id=b2f2e4fe&scoped=true&"
import script from "./ProvinceList.vue?vue&type=script&lang=js&"
export * from "./ProvinceList.vue?vue&type=script&lang=js&"
import style0 from "./ProvinceList.vue?vue&type=style&index=0&id=b2f2e4fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f2e4fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2f2e4fe')) {
      api.createRecord('b2f2e4fe', component.options)
    } else {
      api.reload('b2f2e4fe', component.options)
    }
    module.hot.accept("./ProvinceList.vue?vue&type=template&id=b2f2e4fe&scoped=true&", function () {
      api.rerender('b2f2e4fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prevent/basedata/ProvinceList.vue"
export default component.exports